export const MenuActions = {
    PUBLISH: "publish",
    UNPUBLISH: "unpublish",
    OPEN: "open",
    EDIT: "edit",
    SETTINGS: "settings",
    WORKPLAN_SYNC: "Workplan_sync"
};

export const MAX_TITLE_WIDTH = 155;
export const NEW_CARD_MAX_TITLE_WIDTH = 252;
export const WITHOUT_MORE_CARD_MAX_WIDTH = 235;
